<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-card elevation="4">
                                <v-card-text>
                                    <v-divider class="mt-n3 mb-3"></v-divider>
                                    <v-row>
                                        <v-col v-if="workLoadData.preparer_ids.length == 0" cols="12">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <v-chip color="darkGreen">For Preparation</v-chip>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col v-if="workLoadData.preparer_ids.length > 0" cols="12" md="3">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <div class="font-weight-bold">Prepared By:</div>
                                                    <div v-for="preparer in workloadDetails.preparers" :key="preparer">
                                                        <div class="mt-4">{{ getItemTitle(preparer) }}</div>
                                                        <div class="text-caption font-weight-bold">{{ preparer?.designation }}</div>
                                                    </div>
                                                    <div class="mt-4 text-caption">{{ formatDate(workLoadData.prepared_date) }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col v-if="workLoadData.recommender_approval_ids.length > 0" cols="12" md="3">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <div class="font-weight-bold">Recommending Approval By:</div>
                                                    <div v-for="recommender in workloadDetails.recommenders" :key="recommender">
                                                        <div class="mt-4">{{ getItemTitle(recommender) }}</div>
                                                        <div class="text-caption font-weight-bold">{{ recommender?.designation }}</div>
                                                    </div>
                                                    <div class="mt-4 text-caption">{{ formatDate(workLoadData.recommending_approval_date) }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col v-if="workLoadData.pre_approved_status != null" cols="12" md="3">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <div class="font-weight-bold">Pre Approved By:</div>
                                                    <div class="mt-4">{{ getItemTitle(workloadDetails.pre_approver) }}</div>
                                                    <div class="text-caption font-weight-bold">{{ workloadDetails.pre_approver?.designation }}</div>
                                                    <div class="mt-4 text-caption">{{ formatDate(workLoadData.pre_approved_date) }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col v-if="workLoadData.approved_status != null" cols="12" md="3">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <div class="font-weight-bold">Approved By:</div>
                                                    <div class="mt-4">{{ getItemTitle(workloadDetails.approver) }}</div>
                                                    <div class="text-caption font-weight-bold">{{ workloadDetails.approver?.designation }}</div>
                                                    <div class="mt-4 text-caption">{{ formatDate(workLoadData.approved_date) }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card elevation="3">
                                <v-card-text class="document-card pa-2 pa-md-12">
                                    <v-row class="mt-lg-8">
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label color="black">Faculty:</v-label>
                                                <v-text-field
                                                    v-model="faculty_name"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Employment Status:</v-label>
                                                <v-text-field
                                                    v-model="employment_status"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Designation:</v-label>
                                                <v-text-field
                                                    v-model="designation"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Rank:</v-label>
                                                <v-text-field
                                                    v-model="rank"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Institute:</v-label>
                                                <v-text-field
                                                    v-model="institute"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Department:</v-label>
                                                <v-text-field
                                                    v-model="department"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-lg-8">
                                        <v-col cols="12" md="7" lg="7">
                                            <v-row>
                                                <v-col cols="12" class="text-lg-left">
                                                    <v-label class="font-weight-black text-black">Educational Preparation:</v-label>
                                                </v-col>
                                                <v-col cols="12" class="text-lg-right">
                                                    <div class="d-flex flex-lg-row flex-column ga-2">
                                                        <v-label>Bachelor's Degree:</v-label>
                                                        <v-text-field
                                                            v-model="undergraduate"
                                                            readonly
                                                            color="darkGreen"
                                                            variant="underlined"
                                                            density="comfortable"
                                                            class="font-weight-bold"
                                                            hide-details
                                                        ></v-text-field>
                                                    </div>
                                                </v-col>
                                                <v-col v-if="graduate" cols="12" class="text-lg-right">
                                                    <div class="d-flex flex-lg-row flex-column ga-2">
                                                        <v-label>Master's Degree:</v-label>
                                                        <v-text-field
                                                            v-model="graduate"
                                                            readonly
                                                            color="darkGreen"
                                                            variant="underlined"
                                                            density="comfortable"
                                                            class="font-weight-bold"
                                                            hide-details
                                                        ></v-text-field>
                                                    </div>
                                                </v-col>
                                                <v-col v-if="post_graduate" cols="12" class="text-lg-right">
                                                    <div class="d-flex flex-lg-row flex-column ga-2">
                                                        <v-label>Doctoral/Professional Degree:</v-label>
                                                        <v-text-field
                                                            v-model="post_graduate"
                                                            readonly
                                                            color="darkGreen"
                                                            variant="underlined"
                                                            density="comfortable"
                                                            class="font-weight-bold"
                                                            hide-details
                                                        ></v-text-field>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-lg-8">
                                        <v-col cols="12" md="8" lg="7">
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-row align="center" class="d-flex align-center">
                                                        <v-col cols="3" class="text-lg-right">
                                                            <v-checkbox @update:model-value="toggleTeachApplicable" v-model="is_team_teach" readonly label="Team Teach Applicable?"></v-checkbox>
                                                        </v-col>
                                                        <!-- <v-col v-if="team_teach_name" cols="4" class="text-lg-right">
                                                            <v-btn @click="changeTeamTeach()">Change Team Teach</v-btn>
                                                        </v-col> -->
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            <v-row v-if="is_team_teach">
                                                <v-col cols="12" class="text-lg-left">
                                                    <v-label class="font-weight-black text-black">Team Teaching:</v-label>
                                                </v-col>
                                                <v-col cols="12" class="text-lg-right">
                                                    <div class="d-flex flex-lg-row flex-column ga-2">
                                                        <v-label>Faculty Name:</v-label>
                                                        <v-autocomplete
                                                            v-if="!team_teach_name"
                                                            v-model="teamTeachData"
                                                            @update:model-value="teamTeachEducation"
                                                            color="darkGreen"
                                                            variant="underlined"
                                                            density="comfortable"
                                                            class="font-weight-bold"
                                                            :items="facultyDataForTeamTeach"
                                                            :item-title="getItemTitle"
                                                            item-value="id"
                                                            return-object
                                                            hide-details
                                                        ></v-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            v-model="team_teach_name"
                                                            readonly
                                                            color="darkGreen"
                                                            variant="underlined"
                                                            density="comfortable"
                                                            class="font-weight-bold"
                                                            hide-details
                                                        ></v-text-field>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" class="text-lg-right">
                                                    <div class="d-flex flex-lg-row flex-column ga-2">
                                                        <v-label>Bachelor's Degree:</v-label>
                                                        <v-text-field
                                                            v-model="team_teach_undergraduate"
                                                            readonly
                                                            color="darkGreen"
                                                            variant="underlined"
                                                            density="comfortable"
                                                            class="font-weight-bold"
                                                            hide-details
                                                        ></v-text-field>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" class="text-lg-right">
                                                    <div class="d-flex flex-lg-row flex-column ga-2">
                                                        <v-label>Master's Degree:</v-label>
                                                        <v-text-field
                                                            v-model="team_teach_graduate"
                                                            readonly
                                                            color="darkGreen"
                                                            variant="underlined"
                                                            density="comfortable"
                                                            class="font-weight-bold"
                                                            hide-details
                                                        ></v-text-field>
                                                    </div>
                                                </v-col>
                                                <v-col v-if="team_teach_post_graduate" cols="12" class="text-lg-right">
                                                    <div class="d-flex flex-lg-row flex-column ga-2">
                                                        <v-label>Doctoral/Professional Degree:</v-label>
                                                        <v-text-field
                                                            v-model="team_teach_post_graduate"
                                                            color="darkGreen"
                                                            variant="underlined"
                                                            density="comfortable"
                                                            class="font-weight-bold"
                                                            hide-details
                                                        ></v-text-field>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12" md="8" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Core Time:</v-label>
                                                <v-text-field
                                                    v-model="core_time"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Consultation Time:</v-label>
                                                <v-text-field
                                                    v-model="consultation_time"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12">
                                            <v-card>    
                                                <v-data-table
                                                    :mobile="isMobileOrTablet()"
                                                    :headers="headers"
                                                    :items="courseLoadData"
                                                    :loading="loading"
                                                    :items-per-page="50"
                                                    hide-default-footer
                                                    class="text-caption"
                                                >
                                                <template v-slot:loading>
                                                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                                </template>
                                                <template v-slot:item.datecreated="{ item }">
                                                    <span>{{ formatDateTime(item.datecreated)}} </span>
                                                </template>
                                                <template v-slot:[`item.action`]="{ item }">
                                                    <div class="d-flex justify-end ga-2">
                                                        <v-btn :disabled="workLoadData.approved_status == 'approved'" @click="showFacultyLoadDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                                    </div>
                                                </template>
                                                <template v-slot:no-data>
                                                    <span>No Course Loaded</span>
                                                </template>
                                                </v-data-table>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total Teaching Hours/Wk:</v-label>
                                                <v-text-field
                                                    v-model="total_teaching_hours"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total No. of Preparation:</v-label>
                                                <v-text-field
                                                    v-model="total_preparation"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="ms_load_eqv != 0" dense>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total MS Load Equivalent :</v-label>
                                                <v-text-field
                                                    v-model="ms_load_eqv"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total  No. of MS Student:</v-label>
                                                <v-text-field
                                                    v-model="ms_total_student"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="ge_load_eqv != 0" dense>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total GE Load Equivalent:</v-label>
                                                <v-text-field
                                                    v-model="ge_load_eqv"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total  No. of GE Student:</v-label>
                                                <v-text-field
                                                    v-model="ge_total_student"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="profed_load_eqv != 0" dense>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total ProfEd Load Equivalent :</v-label>
                                                <v-text-field
                                                    v-model="profed_load_eqv"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total  No. of ProfEd Student:</v-label>
                                                <v-text-field
                                                    v-model="profed_total_student"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="gs_load_eqv != 0" dense>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total GS Load Equivalent :</v-label>
                                                <v-text-field
                                                    v-model="gs_load_eqv"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="4" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>Total  No. of GS Student:</v-label>
                                                <v-text-field
                                                    v-model="gs_total_student"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12">
                                            <v-row dense>
                                                <v-col cols="12" class="d-flex flex-column flex-md-row align-center justify-space-between">
                                                    <span class="font-weight-bold text-h6">ADMIN Load Release</span>
                                                </v-col>
                                                <!-- <v-col class="text-right" cols="12" md="6">
                                                    <v-btn
                                                    @click="showAddAdminDialog(user)"
                                                    prepend-icon="mdi-plus"
                                                    class="mt-1 rounded-lg"
                                                    color="routesColor"
                                                    height="40px"
                                                    elevation="2">
                                                        Add Admin Load
                                                    </v-btn>
                                                </v-col> -->
                                                <v-col cols="12" class="mt-1">
                                                    <v-card>    
                                                        <v-data-table
                                                            :mobile="isMobileOrTablet()"
                                                            :headers="loadHeaders"
                                                            :items="adminLoadData"
                                                            :loading="loading"
                                                            hide-default-footer
                                                            class="text-body-2"
                                                        >
                                                        <template v-slot:loading>
                                                            <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                                        </template>
                                                        <template v-slot:item.to_be_counted="{ item }">
                                                            <v-icon v-if="item.to_be_counted == true" color="green">mdi-check</v-icon>
                                                            <v-icon v-else color="red">mdi-close</v-icon>
                                                        </template>
                                                        <template v-slot:item.datecreated="{ item }">
                                                            <span>{{ formatDateTime(item.datecreated)}} </span>
                                                        </template>
                                                        <template v-slot:[`item.action`]="{ item }">
                                                            <div class="d-flex justify-end ga-2">
                                                                <v-btn :disabled="workLoadData.approved_status == 'approved'" @click="showEditAdminLoadDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                                            </div>
                                                        </template>
                                                        <template v-slot:no-data>
                                                            <span>No Admin Load Release</span>
                                                        </template>
                                                        </v-data-table>
                                                    </v-card>
                                                </v-col>   
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12">
                                            <v-row dense>
                                                <v-col cols="12" md="6">
                                                    <span class="font-weight-bold text-h6">RDE Load Release</span>
                                                </v-col>
                                                <!-- <v-col class="text-right" cols="12" md="6">
                                                    <v-btn
                                                    @click="showAddRepDialog(user)"
                                                    prepend-icon="mdi-plus"
                                                    class="mt-1 rounded-lg"
                                                    color="routesColor"
                                                    height="40px"
                                                    elevation="2">
                                                        Add Rep Load
                                                    </v-btn>
                                                </v-col> -->
                                                <v-col cols="12" class="mt-1">
                                                    <v-card>    
                                                        <v-data-table
                                                            :mobile="isMobileOrTablet()"
                                                            :headers="repHeaders"
                                                            :items="repLoadData"
                                                            :loading="loading"
                                                            hide-default-footer
                                                            class="text-body-2"
                                                        >
                                                        <template v-slot:loading>
                                                            <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                                        </template>
                                                        <template v-slot:item.rep_title.title="{ item }">
                                                            <div style="max-width: 800px;">
                                                                <span >
                                                                    {{ item.rep_title.title }}
                                                                </span>

                                                                <span v-if="item.rep_title.category == 'Res'"> (Res)</span>
                                                                <span v-if="item.rep_title.category == 'Ext'"> (Ext)</span>
                                                                <span v-if="item.rep_title.category == 'Prod'"> (Prod)</span>

                                                                <span>({{ item.role  }})</span>
                                                            </div>
                                                        </template>
                                                        <template v-slot:item.datecreated="{ item }">
                                                            <span>{{ formatDateTime(item.datecreated)}} </span>
                                                        </template>
                                                        <template v-slot:[`item.action`]="{ item }">
                                                            <div class="d-flex justify-end ga-2">
                                                                <v-btn :disabled="workLoadData.approved_status == 'approved'" @click="showEditRepLoadDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                                            </div>
                                                        </template>
                                                        <template v-slot:no-data>
                                                            <span>No RDE Load Release</span>
                                                        </template>
                                                        </v-data-table>
                                                    </v-card>
                                                </v-col>   
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12" md="8" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>TOTAL IREPA (Instruction, Research, Extension, Production and Administrative) LOAD UNITS/WK:</v-label>
                                                <v-text-field
                                                    v-model="total_irepa_units"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="8" class="text-lg-right">
                                            <div class="d-flex flex-lg-row flex-column ga-2">
                                                <v-label>TOTAL IREPA (Instruction, Research, Extension, Production and Administrative) LOAD HOURS/WK:</v-label>
                                                <v-text-field
                                                    v-model="total_irepa_hours"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    hide-details
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-menu
                    v-if="action != 'add'"
                    v-model="openWorkloadRemarks"
                    location="bottom center"
                    offset-y
                >
                    <!-- FAB Button as Activator -->
                    <template #activator="{ props }">
                    <v-badge v-if="workloadRemarksData.length > 0" color="red-accent-3" :content="workloadRemarksData.length">
                        <v-btn
                            v-bind="props"
                            :color="openWorkloadRemarks ? '' : 'primary'"
                            variant="flat"
                            elevation="4"
                            icon
                        >
                            <v-icon>{{ openWorkloadRemarks ? 'mdi-close' : 'mdi-comment-text-outline' }}</v-icon>
                        </v-btn>
                    </v-badge>
                    <v-btn
                        v-else
                        v-bind="props"
                        :color="openWorkloadRemarks ? '' : 'primary'"
                        variant="flat"
                        elevation="4"
                        icon
                    >
                        <v-icon>{{ openWorkloadRemarks ? 'mdi-close' : 'mdi-comment-text-outline' }}</v-icon>
                    </v-btn>
                    </template>

                    <!-- Remarks Card -->
                    <v-card
                    class="rounded-lg"
                    style="display: flex; flex-direction: column; width: 400px;"
                    >
                    <v-card-title
                        class="d-flex justify-space-between align-center"
                        style="background-color: #1a5b0f !important;"
                    >
                        <div>
                        <span class="font-weight-bold text-h6 text-white">Remarks</span>
                        </div>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                        <v-timeline side="end">
                        <v-card elevation="0" v-if="workloadRemarksData.length === 0" class="w-100">
                            <v-card-text>No remarks made yet</v-card-text>
                        </v-card>

                        <v-timeline-item
                            v-for="remarks in workloadRemarksData"
                            :key="remarks.id"
                            size="x-small"
                        >
                            <v-alert border="start">
                            <div class="font-weight-bold font-italic">
                                "{{ remarks.details }}"
                            </div>
                            <br>
                            <div class="text-caption">
                                {{ getItemTitle(remarks.user_details) }} -
                                {{ formatDateTime(remarks.datecreated) }}
                            </div>
                            <div v-if="remarks.files && remarks.files.length > 0" class="mt-2">
                                <span class="font-weight-bold">Attachments:</span>
                                <ul>
                                    <li v-for="file in remarks.files.split(',')" :key="file">
                                        <a @click="showViewFileDialog(file)" style="color: #1a5b0f; text-decoration: underline; cursor: pointer;">
                                            {{ file }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div
                                v-if="remarks.user_details.id == $store.state.user.id"
                                class="mt-3"
                            >
                                <v-btn
                                @click="showEditRemarks(remarks)"
                                variant="flat"
                                color="orange-darken-1"
                                size="x-small"
                                >
                                Edit
                                </v-btn>
                            </div>
                            </v-alert>
                        </v-timeline-item>
                        </v-timeline>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-3" style="margin-top: auto;">
                        <v-spacer></v-spacer>
                        <v-btn
                        class="mr-1"
                        :loading="loading"
                        text="Add Remarks"
                        variant="elevated"
                        elevation="1"
                        color="darkGreen"
                        @click="showAddRemarks()"
                        ></v-btn>
                    </v-card-actions>
                    </v-card>
                </v-menu>

                <v-spacer></v-spacer>

                <v-btn
                    class="mr-1"
                    :disabled="loading"
                    text="Cancel"
                    variant="outlined"
                    elevation="1"
                    @click="closeDialog()"
                ></v-btn>

                <v-btn
                    v-if="workLoadData.approved_status == null"
                    class="mr-1"
                    :loading="loading"
                    variant="elevated"
                    elevation="1"
                    color="darkGreen"
                    @click="validateForm()"
                >
                    {{ workLoadData.approved_status == null ? 'Approve and Save' : 'Update and Save' }}
                </v-btn>
                </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmPrepare" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to mark as approved this workload ?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, some details may not be updated. Please review the workload information carefully before proceeding.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmPrepare = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="updateWorkload()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <FacultyLoadDialog ref="FacultyLoadDialog" @refresh="loadAllTotals()"/>
    <AdminLoadDialog ref="AdminLoadDialog" @refresh="loadAllTotals()"/>
    <RepLoadDialog ref="RepLoadDialog" @refresh="loadAllTotals()"/>
    <WorkloadRemarkDialog ref="WorkloadRemarkDialog" @refresh="loadWorkloadRemarks()"/>
    <ViewFileDialog ref="ViewFileDialog"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import FacultyLoadDialog from './Sub-Dialogs/FacultyLoadDialog.vue';
import AdminLoadDialog from './Sub-Dialogs/AdminLoadDialog.vue';
import RepLoadDialog from './Sub-Dialogs/RepLoadDialog.vue';
import { useSnackbar } from '@/composables/useSnackbar';
import WorkloadRemarkDialog from './Sub-Dialogs/WorkloadRemarkDialog.vue';
import ViewFileDialog from './Sub-Dialogs/ViewFileDialog.vue';

export default defineComponent({
     emits: ["refresh"],
     components: {
        FacultyLoadDialog,
        AdminLoadDialog,
        RepLoadDialog,
        WorkloadRemarkDialog,
        ViewFileDialog
     },
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            is_team_teach: false,
            team_teach: null,
            confirmPrepare: false,
            workLoadData: [],
            workloadDetails: [],

            id: null,
            user_id: null,
            faculty_name: null,
            employment_status: null,
            designation: null,
            rank: null,
            institute: null,
            department: null,
            undergraduate: null,
            graduate: null,
            post_graduate: null,
            team_teach_name: null,
            team_teach_undergraduate: null,
            team_teach_graduate: null,
            team_teach_post_graduate: null,
            core_time: null,
            consultation_time: null,
            total_teaching_hours: null,
            total_preparation: null,
            ms_load_eqv: null,
            ms_total_student: null,
            ge_load_eqv: null,
            ge_total_student: null,
            profed_load_eqv: null,
            profed_total_student: null,
            gs_load_eqv: null,
            gs_total_student: null,
            total_irepa_units: null,
            total_irepa_hours: null,
            vpaa_staff_code: null,
            semester_schoolyear_id: this.$store.state.semester_schoolyear.id,
            
            user: [],
            instituteId: null,
            facultyDataForTeamTeach: [],
            teamTeachData: [],
            courseLoadData: [],
            adminLoadData: [],
            repLoadData: [],
            workloadRemarksData: [],
            openWorkloadRemarks: false,

            headers: [
                { title: 'Course No.', align: 'center', sortable: true, key: 'code' },
                { title: 'Course Title', align: 'center', sortable: true, key: 'title' },
                { title: 'Unit', align: 'center', sortable: true, key: 'unit' },
                { title: 'Time', align: 'center', sortable: true, key: 'time' },
                { title: 'Day', align: 'center', sortable: true, key: 'day' },
                { title: 'Room', align: 'center', sortable: true, key: 'room' },
                { title: 'Program/Section', align: 'center', sortable: true, key: 'section_code' },
                { title: 'Class Size', align: 'center', sortable: true, key: 'class_size' },
                { title: 'Hours Lec (a)', align: 'center', sortable: true, key: 'hours_lecture' },
                { title: 'Hours Lab', align: 'center', sortable: true, key: 'hours_lab' },
                { title: 'Actual Contact Teaching Hrs/Wk', align: 'center', sortable: true, key: 'actual_contact_teaching' },
                { title: '.75 Eqv (b)', align: 'center', sortable: true, key: 'eqv' },
                { title: 'Total Load Eqv', align: 'center', sortable: true, key: 'total_eqv' },
                // { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            loadHeaders: [
                { title: 'Description', align: 'center', sortable: true, key: 'description' },
                { title: 'Hours', align: 'center', sortable: true, key: 'hours' },
                { title: 'Unit', align: 'center', sortable: true, key: 'unit' },
                { title: 'To Be Counted', align: 'center', sortable: true, key: 'to_be_counted' },
                // { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            repHeaders: [
                { title: 'SO Number', align: 'center', sortable: true, key: 'rep_title.so_number' },
                { title: 'Description', align: 'center', sortable: true, key: 'rep_title.title' },
                { title: 'Hours', align: 'center', sortable: true, key: 'unit_loading' },
                { title: 'Unit', align: 'center', sortable: true, key: 'unit_loading' },
            ],
        }
     },
     methods: {
        initAdd(instituteId){
            this.dialog = true
            this.dialog_title = 'Faculty Workload'
            this.dialog_sub_title = 'Add new faculty workload'
            this.action = 'add'

            this.instituteId = instituteId
            this.initUsers()
        },
        async initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Faculty Workload'
            this.dialog_sub_title = 'Update faculty workload details'
            this.action = 'edit'

            this.id = data.id
            this.user = data.user
            this.user_id = data.user.id
            this.faculty_name = data.faculty_name
            this.employment_status = data.employment_status
            this.designation = data.designation
            this.rank = data.rank
            this.institute = data.institute
            this.department = data.department
            this.undergraduate = data.undergraduate
            this.graduate = data.graduate
            this.post_graduate = data.post_graduate
            this.team_teach_name = data.team_teach_name
            this.team_teach_undergraduate = data.team_teach_undergraduate,
            this.team_teach_graduate = data.team_teach_graduate,
            this.team_teach_post_graduate = data.team_teach_post_graduate,
            this.core_time = data.core_time
            this.consultation_time = data.consultation_time
            this.vpaa_staff_code = data.vpaa_staff_code

            await this.loadCourseLoad()

            this.total_teaching_hours = data.total_teaching_hours
            this.total_preparation = data.total_preparation
            this.ms_load_eqv = data.ms_load_eqv
            this.ms_total_student = data.ms_total_student
            this.ge_load_eqv = data.ge_load_eqv
            this.ge_total_student = data.ge_total_student
            this.profed_load_eqv = data.profed_load_eqv
            this.profed_total_student = data.profed_total_student
            this.gs_load_eqv = data.gs_load_eqv
            this.gs_total_student = data.gs_total_student

            await this.loadReleaseLoad()

            this.total_irepa_units = data.total_irepa_units
            this.total_irepa_hours = data.total_irepa_hours

            await this.loadWorkloadRemarks()
        },
        async initView(data){
            this.dialog = true
            this.dialog_title = 'Approval Faculty Workload'
            this.dialog_sub_title = 'Faculty workload details'
            this.action = 'view'

            this.workLoadData = data
            this.id = data.id
            this.user = data.user
            this.user_id = data.user.id
            this.faculty_name = data.faculty_name
            this.employment_status = data.employment_status
            this.designation = data.designation
            this.rank = data.rank
            this.institute = data.institute
            this.department = data.department
            this.undergraduate = data.undergraduate
            this.graduate = data.graduate
            this.post_graduate = data.post_graduate
            this.team_teach_name = data.team_teach_name
            this.team_teach_undergraduate = data.team_teach_undergraduate,
            this.team_teach_graduate = data.team_teach_graduate,
            this.team_teach_post_graduate = data.team_teach_post_graduate,
            this.core_time = data.core_time
            this.consultation_time = data.consultation_time
            this.vpaa_staff_code = data.vpaa_staff_code

            if(!this.team_teach_name){
                this.is_team_teach = false
            }
            else{
                this.is_team_teach = true
            }

            await this.loadCourseLoad()

            this.total_teaching_hours = data.total_teaching_hours
            this.total_preparation = data.total_preparation
            this.ms_load_eqv = data.ms_load_eqv
            this.ms_total_student = data.ms_total_student
            this.ge_load_eqv = data.ge_load_eqv
            this.ge_total_student = data.ge_total_student
            this.profed_load_eqv = data.profed_load_eqv
            this.profed_total_student = data.profed_total_student
            this.gs_load_eqv = data.gs_load_eqv
            this.gs_total_student = data.gs_total_student

            await this.loadReleaseLoad()

            this.total_irepa_units = data.total_irepa_units
            this.total_irepa_hours = data.total_irepa_hours

            await this.loadWorkloadRemarks()
            await this.getRelatedUserDetailsByWorkloadId(data.id)
        },
        async initUserForTeamTeach(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/user-details/findAllFacultyByProgramForTeamTeach/' + this.$store.state.user.programId + '/' + this.user_id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.facultyDataForTeamTeach = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async getRelatedUserDetailsByWorkloadId(faculty_workload_id){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-workload/getRelatedUserDetailsByWorkloadId/' + faculty_workload_id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.workloadDetails = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async toggleTeachApplicable(value) {
            if (value) {
                await this.initUserForTeamTeach();
            } else {
                this.teamTeachData = [];
                this.team_teach_name = null;
                this.team_teach_undergraduate = null;
                this.team_teach_graduate = null;
                this.team_teach_post_graduate = null;
            }
        },
        async teamTeachEducation(){
            this.team_teach_name = this.getItemTitle(this.teamTeachData)
            this.team_teach_undergraduate = this.teamTeachData?.undergraduate
            this.team_teach_graduate = this.teamTeachData?.graduate
            this.team_teach_post_graduate = this.teamTeachData?.post_graduate
        },
        async changeTeamTeach(){
            await this.initUserForTeamTeach();
            this.teamTeachData = []
            this.team_teach_name = null
            this.team_teach_undergraduate = null
            this.team_teach_graduate = null
            this.team_teach_post_graduate = null
        },
        async loadUserInfo(){
            if (!this.user) return;
            if(this.user.length == 0) return;

            this.loading = true

            this.user_id = this.user.id
            this.faculty_name = this.user.fname + ' ' + (this.user.mname ? this.user.mname[0] + '.' : '') + ' ' + this.user.lname;
            this.employment_status = this.user.employmentStatus.description
            this.designation = this.user.designation ? this.user.designation : 'None'
            this.rank = this.user.academicRank.description
            this.institute = this.user.office.abbrev
            this.department = this.user.program.abbrev
            this.undergraduate = this.user.undergraduate
            this.graduate = this.user.graduate
            this.post_graduate = this.user.post_graduate,
            this.core_time = this.user.core_time
            this.consultation_time = this.user.consultation_time
            this.semester_schoolyear_id = this.$store.state.semester_schoolyear.id,

            this.loadAllTotals()

        },
        async loadAllTotals(){

            this.loading = true
            await this.loadCourseLoad()

            const totals = this.calculateCourseTypeTotals(this.courseLoadData)
            this.total_teaching_hours = totals.total_teaching_hours
            this.ms_load_eqv = totals.ms_load_eqv
            this.ms_total_student = totals.ms_total_student
            this.ge_load_eqv = totals.ge_load_eqv
            this.ge_total_student = totals.ge_total_student
            this.profed_load_eqv = totals.profed_load_eqv
            this.profed_total_student = totals.profed_total_student
            this.gs_load_eqv = totals.gs_load_eqv
            this.gs_total_student = totals.gs_total_student

            await this.loadReleaseLoad()

            const mergedArray = [...this.adminLoadData, ...this.repLoadData];
            const totalIREPA = this.calculateIREPATotals(totals, mergedArray)
            this.total_irepa_hours = totalIREPA.total_irepa_hours
            this.total_irepa_units = totalIREPA.total_irepa_units

            this.loading = false
        },
        async loadCourseLoad(){
            if (this.workLoadData?.is_snapshot_locked) {
                this.courseLoadData = Array.isArray(this.workLoadData?.course_load_snapshot)
                    ? this.workLoadData.course_load_snapshot
                    : [];
                return;
            }
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllBySemesterAndSchoolyear/' + this.user_id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.courseLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async loadReleaseLoad(){
            if (this.workLoadData?.is_snapshot_locked) {
                this.adminLoadData = Array.isArray(this.workLoadData?.admin_load_snapshot)
                    ? this.workLoadData.admin_load_snapshot
                    : [];
                this.repLoadData = Array.isArray(this.workLoadData?.rep_load_snapshot)
                    ? this.workLoadData.rep_load_snapshot
                    : [];
                return;
            }
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/admin-load/findAllLoadByUserAndSemester/' + this.user_id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.adminLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/rep-unit-load/findAllLoadByUserAndSemester/' + this.user_id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.repLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async loadWorkloadRemarks(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-workload-remarks/findAllRemarksByWorkloadId/' + this.workLoadData?.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.workloadRemarksData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        calculateCourseTypeTotals(data) {
            const totals = {
                ms_load_eqv: 0,
                ms_total_student: 0,
                ge_load_eqv: 0,
                ge_total_student: 0,
                profed_load_eqv: 0,
                profed_total_student: 0,
                gs_load_eqv: 0,
                gs_total_student: 0,
                total_teaching_hours: 0,
            };

            data.forEach(item => {
                totals.total_teaching_hours += item.actual_contact_teaching;
                switch (item.course_type) {
                    case "Major Subject":
                        totals.ms_load_eqv += item.total_eqv;
                        totals.ms_total_student += item.class_size;
                        break;
                    case "General Education":
                        totals.ge_load_eqv += item.total_eqv;
                        totals.ge_total_student += item.class_size;
                        break;
                    case "Professional Education":
                        totals.profed_load_eqv += item.total_eqv;
                        totals.profed_total_student += item.class_size;
                        break;
                    case "Graduate School":
                        totals.gs_load_eqv += item.total_eqv;
                        totals.gs_total_student += item.class_size;
                        break;
                }
            });
            return totals;
        },
        calculateIREPATotals(teachingData, irepaData) {
            const irepaTotals = irepaData.reduce((totals, item) => {
                totals.total_irepa_hours += item.hours;
                totals.total_irepa_units += item.unit;
                return totals;
            }, { total_irepa_hours: 0, total_irepa_units: 0 });

            return {
                total_irepa_hours: teachingData.total_teaching_hours + irepaTotals.total_irepa_hours,
                total_irepa_units: (
                    teachingData.ms_load_eqv +
                    teachingData.ge_load_eqv +
                    teachingData.profed_load_eqv +
                    teachingData.gs_load_eqv +
                    irepaTotals.total_irepa_units
                )
            };
        },
        getItemTitle(item) {
            return `${item?.fname ?? ''} ${item?.mname ? item?.mname[0] + '.' : ''} ${item?.lname ?? ''}${item?.suffix ? ' ' + item?.suffix : ''}`;
        },
        async validateForm(){
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.confirmPrepare = true
            }
        },
        updateWorkload(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            let formData = {
                id: this.id,
                user_id: this.user_id,
                faculty_name: this.faculty_name,
                employment_status: this.employment_status,
                designation: this.designation,
                rank: this.rank,
                institute: this.institute,
                department: this.department,
                undergraduate: this.undergraduate,
                graduate: this.graduate,
                post_graduate: this.post_graduate,
                team_teach_name: this.team_teach_name,
                team_teach_undergraduate: this.team_teach_undergraduate,
                team_teach_graduate: this.team_teach_graduate,
                team_teach_post_graduate: this.team_teach_post_graduate,
                core_time: this.core_time,
                consultation_time: this.consultation_time,
                total_teaching_hours: this.total_teaching_hours,
                total_preparation: this.total_preparation,
                ms_load_eqv: this.ms_load_eqv,
                ms_total_student: this.ms_total_student,
                ge_load_eqv: this.ge_load_eqv,
                ge_total_student: this.ge_total_student,
                profed_load_eqv: this.profed_load_eqv,
                profed_total_student: this.profed_total_student,
                gs_load_eqv: this.gs_load_eqv,
                gs_total_student: this.gs_total_student,
                total_irepa_hours: this.total_irepa_hours,
                total_irepa_units: this.total_irepa_units,
                vpaa_staff_code: this.vpaa_staff_code,
                semester_schoolyear_id: this.semester_schoolyear_id,
                approver_id: this.$store.state.user.id,
                repLoadData: this.repLoadData,
                courseLoadData: this.courseLoadData
            }

            const token = localStorage.getItem('aums-token')

            axios.patch(process.env.VUE_APP_SERVER_URL + '/faculty-workload/updateWithApproved', formData,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.loading = false
                    this.$emit('refresh')
                    showSnackbar('Faculty Workload successfully updated!')
                    this.confirmPrepare = false
                    this.closeDialog()
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            })
        },
        showViewFileDialog(file){
            this.$refs.ViewFileDialog.viewFile(file)
        },
        showFacultyLoadDialog(data){
            this.$refs.FacultyLoadDialog.initUpdate(data)
        },
        showAddAdminDialog(data){
            this.$refs.AdminLoadDialog.initAdd(data)
        },
        showEditAdminLoadDialog(data){
            this.$refs.AdminLoadDialog.initUpdate(data)
        },
        showAddRepDialog(data){
            this.$refs.RepLoadDialog.initAdd(data)
        },
        showEditRepLoadDialog(data){
            this.$refs.RepLoadDialog.initUpdate(data)
        },
        showAddRemarks(){
            this.$refs.WorkloadRemarkDialog.initAdd(this.workLoadData.id)
        },
        showEditRemarks(data){
            this.$refs.WorkloadRemarkDialog.initUpdate(data)
        },
        closeDialog(){
            this.user = []
            this.dialog = false
        }
     }
})
</script>

<style scoped>
/* Document-style form card */
:deep(.document-card) {
    background: #ffffff;
    border-radius: 2px;
    font-size: 13px;
    line-height: 1.25;
    font-family: "Arial", "Helvetica", sans-serif;
}

:deep(.document-card .v-field) {
    border-radius: 2px;
    background: #fff;
    box-shadow: none !important;
}

:deep(.document-card .v-field__overlay),
:deep(.document-card .v-field__underlay) {
    display: none;
}

:deep(.document-card .v-field__input) {
    min-height: 40px;
    padding-top: 4px;
    padding-bottom: 4px;
    color: #111;
    font-weight: 600;
    font-size: 14px;
}

:deep(.document-card .v-input) {
    margin-top: 0px !important;
}

:deep(.document-card .v-field--variant-underlined .v-field__input) {
    min-height: 24px !important;
    padding-top: 0 !important;
    padding-bottom: 1px !important;
    line-height: 1.15 !important;
    display: flex;
    align-items: flex-end;
}

:deep(.document-card .v-field--variant-underlined .v-field__field) {
    align-items: flex-end;
}

:deep(.document-card .v-label) {
    color: #111;
    font-weight: 700;
    font-size: 14px;
}

:deep(.document-card .v-alert) {
    border: 1px solid #444;
    border-radius: 2px;
}

/* Document-like table grid */
:deep(.document-card .v-table) {
    border: 1px solid #333;
    border-radius: 0;
}

:deep(.document-card .v-table table) {
    border-collapse: collapse;
}

:deep(.document-card .v-table thead tr th),
:deep(.document-card .v-table tbody tr td) {
    border: 1px solid #333 !important;
    color: #111;
    font-size: 14px;
    padding: 6px 8px !important;
}

:deep(.document-card .v-table thead tr th) {
    background: #f5f5f5;
    font-weight: 700;
    line-height: 1.15;
}

:deep(.document-card .v-data-table thead th) {
    background: #efefef !important;
    color: #000 !important;
    opacity: 1 !important;
}

:deep(.document-card .v-data-table thead th .v-data-table-header__content) {
    color: #000 !important;
    font-weight: 700 !important;
    font-size: 14px;
    white-space: normal;
    line-height: 1.2;
}

:deep(.document-card .v-data-table thead th .v-icon) {
    display: none !important;
}

:deep(.document-card .v-chip) {
    border-radius: 2px;
    border: 1px solid #245f20;
    font-size: 11px;
    height: 24px;
}

:deep(.document-card .text-h6) {
    font-size: 15px !important;
    line-height: 1.2 !important;
}

:deep(.document-card .text-body-2),
:deep(.document-card .text-body-1),
:deep(.document-card .text-caption) {
    font-size: 12px !important;
    line-height: 1.2 !important;
}

:deep(.document-card .font-weight-bold) {
    letter-spacing: 0;
}

/* Unified label/input layout */
:deep(.doc-form-section .d-flex.flex-lg-row.flex-column) {
    display: grid !important;
    grid-template-columns: 220px minmax(0, 1fr);
    column-gap: 10px;
    align-items: end;
}

:deep(.doc-form-section .d-flex.flex-lg-row.flex-column .v-label) {
    justify-self: end;
    align-self: end;
    margin-bottom: 1px;
    white-space: nowrap;
}

:deep(.doc-form-section .d-flex.flex-lg-row.flex-column .v-input) {
    margin-top: 0 !important;
}

:deep(.doc-form-section .v-field--variant-underlined .v-field__input) {
    min-height: 24px !important;
    padding-top: 0 !important;
    padding-bottom: 1px !important;
    line-height: 1.15 !important;
    display: flex;
    align-items: flex-end;
}

:deep(.doc-form-section .v-field--variant-underlined .v-field__field) {
    align-items: flex-end;
}

:deep(.doc-form-section .v-col > .v-row.align-center) {
    display: grid;
    grid-template-columns: 220px minmax(0, 1fr);
    column-gap: 10px;
    align-items: end;
}

:deep(.doc-form-section .v-col > .v-row.align-center > .v-col:first-child) {
    max-width: 100% !important;
    flex: initial !important;
    justify-self: end;
    align-self: end;
    padding-top: 0;
    padding-bottom: 0;
}

:deep(.doc-form-section .v-col > .v-row.align-center > .v-col:last-child) {
    max-width: 100% !important;
    flex: initial !important;
    padding-top: 0;
    padding-bottom: 0;
}

@media (max-width: 960px) {
    :deep(.doc-form-section .d-flex.flex-lg-row.flex-column) {
        grid-template-columns: 1fr;
        row-gap: 4px;
    }

    :deep(.doc-form-section .d-flex.flex-lg-row.flex-column .v-label) {
        justify-self: start;
    }

    :deep(.doc-form-section .v-col > .v-row.align-center) {
        grid-template-columns: 1fr;
        row-gap: 4px;
    }

    :deep(.doc-form-section .v-col > .v-row.align-center > .v-col:first-child) {
        justify-self: start;
    }
}
</style>